import $ from 'jquery';

window.$ = window.jQuery = $;

$(window).on('load', function () {
    window.$preloader = $('.loaderArea');
    window.$loader = window.$preloader.find('.loader');
    window.$loader.fadeOut();
    window.$preloader.delay(650).fadeOut('slow');

    $('.open-nav').on('click', function () {
        $('.wrap-nav').addClass('open');
        $('.overlay').addClass('open');
    });

    $('.close-nav, .overlay').on('click', function () {
        $('.wrap-nav').removeClass('open');
        $('.overlay').removeClass('open');
    });

    $('.question').next().hide();
    $('.question').on('click', function () {
        $(this).closest('.faq-item').toggleClass('is_open').siblings().removeClass('is_open');
        $(this).next().stop(true, true).slideToggle();
        $('.question').not(this).next().stop(true, true).slideUp();
    });
});
